import React from 'react'
import CombinedSetStatisticsPage from './CombinedSetStatisticsPage'

const CombinedSetStatisticsContainer = () => {
    return (
        <CombinedSetStatisticsPage />
    )
}

export default CombinedSetStatisticsContainer